import React, { useMemo, Fragment } from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../../../constant/TYPE";
import View from "./view/View";
import Input from "./input/Input";
import EntryPopup from "../popup/EntryPopup";
import EntryPopupGlobal from "../../presentationalGlobal/popup/EntryPopup";
import OXPopup from "../popup/OXPopup";
import RelayWrongAnswerPopup from "../popup/RelayWrongAnswerPopup";
import RelayWrongAnswerPopupGlobal from "../../presentationalGlobal/popup/RelayWrongAnswerPopup";
import AIMessagePopup from "../popup/AIMessagePopup";
import AIMessagePopupGlobal from "../../presentationalGlobal/popup/AIMessagePopup";
import AnsweringCompletePopup from "../popup/AnsweringCompletePopup";
import AnsweringCompletePopupGlobal from "../../presentationalGlobal/popup/AnsweringCompletePopup";
import LoadingPopup from "../popup/LoadingPopup";
import ScribbleTooltip from "./ScribbleTooltip";
import clsx from "clsx";

const Body = ( props ) => {

  const user = useSelector( state => state.user );
  const loading = useSelector( state => state.loading );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );

  const {
    Viewer,
    Inputer,
    EntryPopupHider,
    ScribbleTooltipHider,
    OXPopupHider,
    RelayWrongAnswerPopupHider,
    AIMessagePopupHider,
    Jumper,
    children,
    ...PROPS
  } = props;

  const Components = useMemo( () => {
    if ( TYPE.CHANNEL.GLOBAL01 === user.info.channelCode && TYPE.ENTRY_TYPE.GLOBAL01 === user.info.entryType ) {
      return {
        EntryPopup : EntryPopupGlobal,
        RelayWrongAnswerPopup : RelayWrongAnswerPopupGlobal,
        AIMessagePopup : AIMessagePopupGlobal,
        AnsweringCompletePopup : AnsweringCompletePopupGlobal
      };
    } else {
      return {
        EntryPopup,
        RelayWrongAnswerPopup,
        AIMessagePopup,
        AnsweringCompletePopup
      };
    }
  }, [ user.info.channelCode, user.info.entryType ] );

  return (
    <div className="container">
      <div className="inner">
        <div 
          className={
            clsx(
              "learningBox",
              (answeringQuestions.data.objctYn === 'Y') && 'multiple'
            )
          }
        >
          <Viewer><View { ...PROPS } /></Viewer>
          <Inputer><Input { ...PROPS } /></Inputer>
        </div>
        { answeringQuestions.isShowEntryPopup && !answeringQuestions.isResumeYn && <EntryPopupHider><Components.EntryPopup /></EntryPopupHider> }
        { answeringQuestions.isShowOXPopup && <OXPopupHider><OXPopup /></OXPopupHider> }
        { answeringQuestions.isShowRelayWrongAnswerPopup && <RelayWrongAnswerPopupHider><Components.RelayWrongAnswerPopup /></RelayWrongAnswerPopupHider> }
        { answeringQuestions.isShowAIMessagePopup && <AIMessagePopupHider><Components.AIMessagePopup /></AIMessagePopupHider> }
        { answeringQuestions.resultData.prgsCd && <Jumper><Components.AnsweringCompletePopup /></Jumper> }
        { loading.isShowBall && <LoadingPopup /> }
      </div>
      { !! questionView.scribbleTooltipStatus && <ScribbleTooltipHider><ScribbleTooltip /></ScribbleTooltipHider> }
    </div>
  );

};

Body.defaultProps = {
  Viewer : Fragment,
  Inputer : Fragment,
  EntryPopupHider : Fragment,
  ScribbleTooltipHider : Fragment,
  OXPopupHider : Fragment,
  RelayWrongAnswerPopupHider : Fragment,
  AIMessagePopupHider : Fragment,
  Jumper : Fragment
};

export default Body;
